import { Component, OnInit, Inject, AfterViewInit } from "@angular/core";
import { COMMA, ENTER, ESCAPE } from "@angular/cdk/keycodes";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Methods } from "../../methods";
import { MatChipInputEvent } from "@angular/material/chips";
import { MailBoxService } from './mail-box.service';

import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";

declare const $: any;

declare interface Body {
  from: string[];
  to: string[];
  cc: string[];
  bcc: string[];
  element_id: number;
  type: string;
  subject: string;
  msg: string;
}

export interface Fruit {
  name: string;
}

/**
 * @title Chips with input
 */

@Component({
  selector: "app-mail-box",
  templateUrl: "./mail-box.component.html",
  styleUrls: ["./mail-box.component.css"],
})
export class MailBox implements OnInit, AfterViewInit {
  public mtds: Methods = new Methods();
  public valueTo = "";
  public valueCC = "";
  public valueBCC = "";
  public none = "350px";
  public sending = false;
  public Editor = ClassicEditor;

  public attachmen: Array<any> = [];
  public loadingAtachmen = false;
  constructor(
    private _service: MailBoxService,
    public dialogRef: MatDialogRef<MailBox>,
    @Inject(MAT_DIALOG_DATA) public body: Body
  ) {
    this.loadingAtachmen = true;
    this._service.getAttachmen({
      type: body.type,
      idElement: body.element_id,
    }).subscribe(
      r => {
        console.log(r);
        this.attachmen.push({
          name: r.filename,
          file: r.file,
          size: Number(r.size)
        });

        if (body.type === 'Shipmentlabel') {
          body.msg = r.bodyMail;
          body.subject = r.subjectMail;
        }
        this.loadingAtachmen = false;
      }, error => {
        this.loadingAtachmen = false;
      }
    );
  }

  ngOnInit() {
    console.log(this.body);

    // let editor = this.
  }

  goLink(link) {
    window.open(link);
  }

  removeAtachmen(i) {
    this.attachmen.splice(i, 1);
  }

  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA, ESCAPE];
  // fruits: Fruit[] = [{ name: "Lemon" }, { name: "Lime" }, { name: "Apple" }];

  addTo(event: MatChipInputEvent): void {
    console.log(event);
    const value = (event.value || "").trim();

    // Add our fruit
    if (value) {
      this.body.to.push(value);
    }

    // Clear the input value
    this.valueTo = "";
  }

  removeTo(mail: string): void {
    const index = this.body.to.indexOf(mail);

    if (index >= 0) {
      this.body.to.splice(index, 1);
    }
  }

  addCC(event: MatChipInputEvent): void {
    console.log(event);
    const value = (event.value || "").trim();

    // Add our fruit
    if (value) {
      this.body.cc.push(value);
    }

    // Clear the input value
    this.valueCC = "";
  }

  removeCC(mail: string): void {
    const index = this.body.cc.indexOf(mail);

    if (index >= 0) {
      this.body.cc.splice(index, 1);
    }
  }

  addBCC(event: MatChipInputEvent): void {
    console.log(event);
    const value = (event.value || "").trim();

    // Add our fruit
    if (value) {
      this.body.bcc.push(value);
    }

    // Clear the input value
    this.valueBCC = "";
  }

  removeBCC(mail: string): void {
    const index = this.body.bcc.indexOf(mail);

    if (index >= 0) {
      this.body.bcc.splice(index, 1);
    }
  }

  validar(correo) {
    // ^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$
    var emailReg =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!emailReg.test(correo)) {
      return false;
    } else {
      return true;
    }
  }

  send() {
    this.sending = true;
    console.log(this.body);
    let json = {
      to: this.body.to,
      cc: this.body.cc,
      bcc: this.body.bcc,
      subject: this.body.subject,
      body: this.body.msg,
      attachments: this.attachmen.length > 0 ? this.attachmen[0].file : ""
    };

    this._service.sendMail(json).subscribe(
      r => {
        console.log(r);

        if (r.status === 'success') {
          this.mtds.notifySuccess(r.msg);
          this.close();
        } else {
          this.mtds.notifyError(r.msg);
        }
        this.sending = false;
      }
    );
  }

  close() {
    this.dialogRef.close();
  }

  ngAfterViewInit() {
    $(".ck-editor__editable").hide();
  }
}
